import './Card.css';

const Card = (props) => {

return <div className="card1">{props.children}</div>;
}

export default Card;